import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import {
  driverReducer,
  uiReducer,
  timingReducer,
  reclamoReducer,
  ordersReducer,
  merchantReducer,
  mapReducer,
  refundReducer,
  newRefundReducer,
} from "../reducers";
import { authReducer } from "../reducers/authReducer";

const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const changeDataUiMiddleware = (store) => (next) => (action) => {
  const { type } = action;
  next(action);
  if (
    type === "[ui] showDriverBusy" ||
    type === "[ui] showDriverFree" ||
    type === "[ui] showGoup" ||
    type === "[ui] showOrdersInProccess" ||
    type === "[ui] showOrdersReady" ||
    type === "[ui] showOrdersDispatched" ||
    type === "[ui] showOrdersDispatchedMarker" ||
    type === "[ui] showOrdersAssigned" ||
    type === "[ui] showOrdersUnassgined" ||
    type === "[ui] off switch top" ||
    type === "[ui] off switch buttom" ||
    type === "[ui] setCity" ||
    type === "[ui] activeTabPanelRight" ||
    type === "[ui] activeTabPanelLeft" ||
    type === "[ui] showVehicleType" ||
    type === "[ui] showActiveOrders"
  ) {
    const dataUi = store.getState().ui;
    localStorage.setItem("configUser", JSON.stringify(dataUi));
  }
};

const reducers = combineReducers({
  drivers: driverReducer,
  orders: ordersReducer,
  ui: uiReducer,
  map: mapReducer,
  timings: timingReducer,
  reclamos: reclamoReducer,
  merchants: merchantReducer,
  auth: authReducer,
  refunds: refundReducer,
  newRefunds: newRefundReducer,
});

export const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk, changeDataUiMiddleware))
);
